import request from '@/utils/request'
// import qs from 'qs'

// 分页查看所有设备动态属性
export const dynamicList = (getData) => {
  return request({
    url: '/back/check_device_dynamic/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    // data: postData
    params: getData
  })
}
// 根据id删除
export const deleteDynamic = (getData) => {
  return request({
    url: '/back/check_device_dynamic/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 修改动态属性
export const updateDynamic = (postData) => {
  return request({
    url: '/back/check_device_dynamic/update',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}

// 新增动态属性
export const addDynamic = (postData) => {
  return request({
    url: '/back/check_device_dynamic/save',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
